const schemaReduced = {
  id: "",
  serial: ""
};

export default schemaReduced;
